'use strict';

const Analytics = require('./analytics');

class AnalyticsListings extends Analytics {
    pushIndexesFor (lists) {
        let indexes = {};
        for (let i = 0; i < lists.length; i++) {
            indexes[lists[i].class] = 0;
        }
        return indexes;
    }

    init (globalContainer, helperContainer) {
        this.logName = 'AnalyticsListings';
        super.init(globalContainer, helperContainer);

        this.listingItemsBaseClass = '.analytics.pageType.listing';
        this.orderDetailsItemsBaseClass = '.analytics.pageType.orderDetails';
        this.analyticsDataContainer = '.analytics.productListingItem';
        this.pushedSlickSlides = [];
        this.mobileBannerCarouselItemsPushed = [];
        this.openedCarousels = [];
        this.activeCarouselId = undefined;
        this.pushedItems = [];
        this.completeYourLookPushedItems = [];

        this.listsAvailable = this.helper.getAvailableListTypes(this.listingItemsBaseClass);
        this.pushedIndexes = this.pushIndexesFor(this.listsAvailable);

        this.prepareObservers();
        this.prepareTilesObservers();
        // wait for the async call to cross sell to push lists when completeYourLook is available
        if (this.listsAvailable.filter(function (i) { return i.class === 'suggestedProducts' || i.class === 'theMostPopular' || i.class === 'js-youMayAlsoLike'; }).length === 0) {
            this.prepareProductObservers();
            this.pushAllLists();
        }
        var _self = this;
        $(document).ready(function () {
            if ($('.page').data('action') === 'Home-Show') {
                _self.prepareHomepageObservers();
                _self.pushProductSliderHome();
            }
        });
    }

    fillListData (wrapper) {
        let container = $(wrapper.associatedObject + ' .product-tile').find(this.analyticsDataContainer);
        let itemListName = wrapper.value;
        if ((wrapper.value === 'complete_your_look' && $('.promoCrossSellEnabled').length) || wrapper.value === 'complete_the_promo_minicart') {
            itemListName = 'complete_the_promo';
        }
        for (let i = 0; i < container.length; i++) {
            container.eq(i).attr('data-index', i);
            container.eq(i).attr('data-item_list_name', itemListName);

            if (container.eq(i).closest('.slick-slide').length) {
                this.pushedSlickSlides.push(container.eq(i).closest('.slick-slide').data('slickIndex'));
            }
        }
    }

    fillListDataHome (wrapper, carouselNum) {
        $(wrapper.class).eq(carouselNum).find(this.analyticsDataContainer).toArray().forEach((item, index) => {
            item.setAttribute('data-index', index);
            item.setAttribute('data-item_list_name', wrapper.value);
            item.setAttribute('data-item_list_id', this.helper.getListId());
        });
    }

    fillAllListData () {
        let _self = this;

        this.listsAvailable.forEach(function (listing) {
            _self.fillListData(listing);
        });
    }

    getInfo (wrapper) {
        this.fillListData(wrapper);

        let items = [];
        let container = $(wrapper.associatedObject).find(this.analyticsDataContainer);
        const isNotMobile = Foundation.MediaQuery.atLeast('medium');
        if (wrapper.value === 'complete_your_look' || wrapper.value === 'complete_the_promo') {
            this.completeYourLookPushedItems = [];
        }
        let allProducts = $(wrapper.associatedObject).find('.slick-slide ' + this.analyticsDataContainer);
        if (allProducts.length > 0 && (isNotMobile || (wrapper.value !== 'complete_your_look' && wrapper.value !== 'complete_the_promo'))) {
            container = $(wrapper.associatedObject).find('.slick-slide.slick-active ' + this.analyticsDataContainer);
        }

        const sortingContainer = document.querySelector('.sort-order-item input[type="radio"]:checked');
        const formattedListName = this.helper.formatString(wrapper.value) || 'default_list';
        const itemListName = formattedListName === 'complete_your_look' ? 'match_with' : formattedListName;
        for (let i = 0; i < container.length; i++) {
            let obj = container.eq(i).data();
            if (sortingContainer) {
                obj.item_list_name = this.helper.getSortingType(sortingContainer);
            } else if (wrapper.class !== 'orderDetailsPage') {
                obj.item_list_name = itemListName;
            }

            if (!obj.index) {
                obj.index = i;
            }

            obj.item_list_id = obj.item_list_id || this.helper.getListId(wrapper.associatedObject) || 'default_id';
            items.push(this.helper.formatProductForAnalytics(obj));

            if (wrapper.value === 'complete_your_look' || wrapper.value === 'complete_the_promo') {
                if (i < 2) {
                    this.completeYourLookPushedItems.push(i);
                }
            } else {
                this.pushedItems.push(i);
            }
        }

        const _self = this;

        $('body').on('afterChange', '#crossSellContainer, ' + wrapper.associatedObject, function (event, slick, currentSlide, nextSlide) {
            const allActive = (isNotMobile || (wrapper.value !== 'complete_your_look' && wrapper.value !== 'complete_the_promo')) ? $(wrapper.associatedObject).find('.slick-slide.slick-active ' + _self.analyticsDataContainer) : $(wrapper.associatedObject).find('.slick-slide ' + _self.analyticsDataContainer);
            let allProducts = $(wrapper.associatedObject).find('.slick-slide ' + _self.analyticsDataContainer);
            let totalProductsNumber = allProducts.length;
            let actualLast = _self.completeYourLookPushedItems.length > 0 ? _self.completeYourLookPushedItems[_self.completeYourLookPushedItems.length - 1] : 0;
            let items = [];
            const itemListId = itemListName === 'you_may_also_like' ? _self.helper.getListId(null, 'google') : _self.helper.getListId();
            for (let i = 0; i < allActive.length; i++) {
                let obj = allActive.eq(i).data();
                obj.item_list_name = itemListName;
                obj.item_list_id = itemListId;

                const item = _self.helper.formatProductForAnalytics(obj);
                item.index = allActive.eq(i).parents('.slick-slide').data('slick-index');
                if ((wrapper.value === 'complete_your_look' || wrapper.value === 'complete_the_promo') && allActive.eq(i).parents('.slick-slide.slick-active').length !== 0) {
                    actualLast = allActive.eq(i).parents('.slick-slide.slick-active').data('slick-index');
                }
                if (item.index < 0) {
                    item.index += totalProductsNumber;
                }
                if (wrapper.value !== 'complete_your_look' && wrapper.value !== 'complete_the_promo' && _self.pushedItems.indexOf(item.index) === -1) {
                    items.push(item);
                    _self.pushedItems.push(item.index);
                } else if ((wrapper.value === 'complete_your_look' || wrapper.value === 'complete_the_promo') && _self.completeYourLookPushedItems.indexOf(item.index) === -1) {
                    items.push(item);
                    _self.completeYourLookPushedItems.push(item.index);
                }
            }
            _self.log('Pushing for ' + wrapper.value, true);

            if (items.length > 0) {
                const pushObject = {
                    event: 'view_item_list',
                    ss_event_id: Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
                    ecommerce: {
                        currency: _self.helperData.currency,
                        item_list_name: itemListName,
                        item_list_id: itemListId,
                        items: items,
                    },
                };

                _self.push({ecommerce: null});
                _self.push(pushObject);
                _self.pushedIndexes[wrapper.class] = items.length;
                _self.log('Indexes pushed to: ', true);
                _self.log(_self.pushedIndexes);
            }
        });

        $('body').on('listing:changeVariant', function (e, data) {
            const element = $(data.container).find('.analytics.productListingItem').data();
            const item = _self.helper.formatProductForAnalytics(element);

            // Pointer for array product
            var i = 0;
            var l = 8;
            _self.pushObjectMax({
                items: [item],
                i,
                l,
                itemListName: 'listing',
                itemListId: _self.helper.getListId(data.container) || 'default_id',
            });
        });

        return items;
    }

    pushData (wrapper, start = 0, length = -1) {
        if (length === 4 && wrapper.class === 'suggestedProductsMobile') {
            return;
        }
        if (length === 2 && wrapper.class === 'suggestedProducts') {
            return;
        }

        if (wrapper.value === 'complete_the_promo_minicart') {
            wrapper.value = 'complete_the_promo';
        } else if (wrapper.value === 'complete_your_look_minicart') {
            wrapper.value = 'complete_your_look';
        }

        let items = this.getInfo(wrapper);
        if (items.length === 0) {
            return;
        }

        let itemsToPush = items.slice(this.pushedIndexes[wrapper.class], items.length);
        if (itemsToPush.length === 0) {
            return;
        }

        // all items have equal item_list_id, and top level item_list_id must be the same as well
        const itemListId = items[0].item_list_id;

        if (wrapper.value === 'the_most_popular' || wrapper.value === 'recently_viewed' || wrapper.value === 'you_may_also_like' || wrapper.value === 'buy_it_again' || wrapper.value === 'similar_products') {
            let pushObject = {
                'event': 'view_item_list',
                'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
                'ecommerce': {
                    'currency': this.helperData.currency,
                    'item_list_name': this.helper.formatString(wrapper.value),
                    'item_list_id': itemListId,
                    'items': items
                }
            };

            if (wrapper.class === 'orderDetailsPage') {
                const isAllSameItemListName = items.every(item => item.item_list_name === items[0].item_list_name);
                if (isAllSameItemListName) {
                    pushObject.ecommerce.item_list_name = items[0].item_list_name;
                } else {
                    delete pushObject.ecommerce.item_list_name;
                    delete pushObject.ecommerce.item_list_id;
                }
            }

            this.push({ecommerce: null});
            this.push(pushObject);
            this.pushedIndexes[wrapper.class] = items.length;
            this.log('Indexes pushed to: ', true);
            this.log(this.pushedIndexes);
        } else {
            this.log('Pushing for ' + wrapper.value, true);
            // Pointer for array product
            if (wrapper.value === 'complete_your_look' || wrapper.value === 'complete_the_promo') {
                this.pushObjectRange({
                    items,
                    start,
                    length: length,
                    itemListName: wrapper.value === 'complete_your_look' ? 'match_with' : wrapper.value,
                    itemListId: itemListId
                });
            } else if (wrapper.value === 'wishlist' || wrapper.value === 'listing' || wrapper.value === 'search' || wrapper.value === 'filter_applied' || wrapper.value === 'free_product') {
                for (var j = 0; j < items.length; j++) {
                    items[j].index = j;
                }
                this.pushObjectMax({
                    items: items,
                    i: 0,
                    l: 8,
                    itemListName: wrapper.value,
                    itemListId: itemListId
                });
            }
        }
    }

    pushAllLists () {
        let _self = this;

        if (this.listsAvailable.length === 0) {
            return;
        }
        this.fillAllListData();

        this.listsAvailable = this.helper.getAvailableListTypes('.analytics.pageType.listing');

        this.listsAvailable.forEach(function (listing) {
            _self.pushData(listing);
        });
    }

    pushList (list, start = 0, length = -1) {
        let _self = this;

        if (this.listsAvailable.length === 0) {
            return;
        }

        this.listsAvailable = this.helper.getAvailableListTypes('.analytics.pageType.listing');
        this.listsAvailable.forEach(function (listing) {
            if (listing.value === list) {
                _self.pushData(listing, start, length);
            }
        });
    }

    pushOrderDetailsList (list, start = 0, length = -1) {
        let _self = this;

        const listsAvailable = this.helper.getAvailableListTypes(this.orderDetailsItemsBaseClass);
        if (listsAvailable.length === 0) {
            return;
        }

        listsAvailable.forEach(function (listing) {
            if (listing.value === list) {
                _self.pushData(listing, start, length);
            }
        });
    }

    formatHomepageProduct (rawItem) {
        let pushItem = this.helper.formatProductForAnalytics($(rawItem).data());
        return pushItem;
    }

    getNewActiveSlides (carouselSlides, carouselId) {
        let analyticsArray = [];

        carouselSlides.forEach(item => {
            if ($(item).hasClass('swiper-slide-prev') || $(item).hasClass('swiper-slide-active') || $(item).hasClass('swiper-slide-next')) {
                let itemId = carouselId + '-' + $(item).attr('aria-label');

                if (this.pushedSlickSlides.indexOf(itemId) === -1) {
                    this.pushedSlickSlides.push(itemId);
                    analyticsArray.push(this.formatHomepageProduct($(item).find(this.analyticsDataContainer)));
                }
            }
        });

        if (analyticsArray.length) {
            this.pushObjectMax({
                items: analyticsArray,
                i: 0,
                l: 8,
                itemListName: 'listing',
                itemListId: this.helper.getListId()
            });
        }
    }

    getInfoHome (wrapper, carouselNum) {
        if (wrapper.associatedObject === 'filmstrip-carousel') {
            let analyticsArray = [];
            let isMobile = Foundation.MediaQuery.atLeast('medium');
            let carouselId = $(wrapper.class).find('.swiper-wrapper').attr('id');

            $(wrapper.class).find('.cm-product-item').toArray().forEach((item, index) => {
                let analyticsDiv = $(item).find(this.analyticsDataContainer);
                $(analyticsDiv).attr('data-index', index);
                $(analyticsDiv).attr('data-item_list_name', wrapper.value);
                $(analyticsDiv).attr('data-item_list_id', this.helper.getListId());

                if (!isMobile) {
                    if ($(item).hasClass('swiper-slide-active') || $(item).hasClass('swiper-slide-next')) {
                        this.pushedSlickSlides.push(carouselId + '-' + $(item).attr('aria-label'));
                        analyticsArray.push(this.formatHomepageProduct(analyticsDiv));
                    }
                } else {
                    this.pushedSlickSlides.push(carouselId + '-' + $(item).attr('aria-label'));
                    analyticsArray.push(this.formatHomepageProduct(analyticsDiv));
                }
            });
            return analyticsArray;
        }

        if (wrapper.associatedObject === 'focus-carousel') {
            let analyticsArray = [];
            let carouselId = $(wrapper.class).eq(carouselNum).find('.swiper-wrapper').attr('id');
            let allProducts = $(wrapper.class).eq(carouselNum).find('.swiper-slide');

            if (allProducts.length > 0) {
                allProducts.toArray().forEach((prod) => {
                    this.pushedSlickSlides.push(carouselId + '-' + $(prod).attr('aria-label'));
                    analyticsArray.push(this.formatHomepageProduct($(prod).find(this.analyticsDataContainer)));
                });
            }
            return analyticsArray;
        }

        if (wrapper.associatedObject === 'shopBy-carousel') {
            let analyticsArray = [];
            let carouselId = $(wrapper.class).find('.swiper-wrapper').attr('id');

            $(wrapper.class).find('.cm-product-item').toArray().forEach((item, index) => {
                let analyticsDiv = $(item).find(this.analyticsDataContainer);
                $(analyticsDiv).attr('data-index', index);
                $(analyticsDiv).attr('data-item_list_name', wrapper.value);
                $(analyticsDiv).attr('data-item_list_id', this.helper.getListId());

                if (analyticsDiv.length) {
                    this.pushedSlickSlides.push(carouselId + '-' + $(item).attr('aria-label'));
                    analyticsArray.push(this.formatHomepageProduct(analyticsDiv));
                }
            });
            return analyticsArray;
        }
    }

    pushProductSliderHome () {
        let _self = this;

        var wrapper = {
            class: '',
            value: 'carousel_home',
            associatedObject: ''
        };

        const productFilmstripCarousel = $('.cm-product-filmstrip__container.swiper-container');
        const focusCarousel = $('.cm-focus-carousel.swiper-container');
        const singleHeroBanner = $('.cm-single-hero-banner-container');
        const specialCategoryBanner = $('.cm-special-category-banner');
        const shopByCarousel = $('.cm-productList.swiper-container.cm-current');

        if (singleHeroBanner.length) {
            wrapper.associatedObject = '.cm-single-hero-banner-container .cm-popup__container';
            wrapper.value = 'landing_home';
            this.fillListData(wrapper);
        }

        if (specialCategoryBanner.length) {
            wrapper.associatedObject = '.cm-special-category-banner .cm-special-category-banner_image-content.show-for-large .cm-popup__container';
            wrapper.value = 'landing_home';
            this.fillListData(wrapper);
        }

        if (productFilmstripCarousel.length) {
            wrapper.class = '.cm-product-filmstrip__container.swiper-container';
            wrapper.value = 'filmstrip_home';
            wrapper.associatedObject = 'filmstrip-carousel';

            let pushObject = this.getInfoHome(wrapper);

            const numOfDisplyedItems = [];
            const numOfHiddenItems = [];
            let shownItems = [];
            let carouselItems = {};
            let ArrLength = 0;
            let fromSlice = 0;
            let toSlice = 0;
            let itemListsName = [];

            productFilmstripCarousel.each(function (idx) {
                const shopTheLook = $(this).parents('.cm-shopTheLook');
                const filmstrip = $(this).parents('.cm-product-filmstrip');

                if (shopTheLook.length) {
                    itemListsName.push('shop_the_look');
                }

                if (filmstrip.length) {
                    itemListsName.push('filmstrip');
                }

                if (this && this.swiper && this.swiper.slides) {
                    this.swiper.slides.forEach(function (el, idx) {
                        if (pushObject[idx + ArrLength]) {
                            pushObject[idx + ArrLength].index = idx;
                        }

                        if (shopTheLook && shopTheLook.length && pushObject[idx + ArrLength]) {
                            pushObject[idx + ArrLength].item_list_name = 'shop_the_look';
                        }

                        if (filmstrip && filmstrip.length && pushObject[idx + ArrLength]) {
                            pushObject[idx + ArrLength].item_list_name = 'filmstrip';
                        }
                    });

                    const carouselId = $(this).find('.cm-product-filmstrip__wrapper').attr('id');
                    const calculateDisplayedItems = Math.floor(this.swiper.size / this.swiper.slides[0].clientWidth);
                    numOfDisplyedItems.push(calculateDisplayedItems);
                    numOfHiddenItems.push(this.swiper.slides.length - calculateDisplayedItems);

                    if (idx === 0) {
                        toSlice = calculateDisplayedItems;
                    } else {
                        toSlice = ArrLength + calculateDisplayedItems;
                    }

                    shownItems = [...shownItems, ...pushObject.slice(fromSlice, toSlice)];
                    ArrLength += this.swiper.slides.length;

                    carouselItems = {
                        ...carouselItems,
                        [carouselId]: [...pushObject.slice(fromSlice, ArrLength)]
                    };

                    fromSlice = ArrLength;
                }
            });

            if (pushObject) {
                this.pushObjectMax({
                    items: shownItems,
                    i: 0,
                    l: numOfDisplyedItems,
                    itemListName: itemListsName,
                    itemListId: this.helper.getListId()
                });
            }

            const carouselItemTracker = {};

            $('.cm-arrows__wrapper-next').on('click', function () {
                wrapper.value = 'filmstrip_home';
                const carouselId = $(this).attr('aria-controls');
                const carouselContainer = $(`#${carouselId}`).parent();
                const calculateDisplayedItems = Math.floor(carouselContainer[0].swiper.size / carouselContainer[0].swiper.slides[0].clientWidth);
                let selectedItem = [];

                if (!carouselItemTracker[carouselId]) {
                    carouselItemTracker[carouselId] = calculateDisplayedItems;
                } else {
                    carouselItemTracker[carouselId]++;
                }

                if (carouselItems.hasOwnProperty(`${carouselId}`)) {
                    const carouselItemNum = carouselItemTracker[carouselId];
                    selectedItem.push(carouselItems[carouselId][carouselItemNum]);
                }

                if (carouselItemTracker[carouselId] < Number(carouselContainer[0].swiper.slides.length)) {
                    _self.pushObjectMax({
                        items: selectedItem,
                        i: 0,
                        l: 1,
                        itemListName: wrapper.value,
                        itemListId: _self.helper.getListId()
                    });
                }
            });
        }

        if (shopByCarousel.length) {
            wrapper.class = '.cm-productList.swiper-container.cm-current';
            wrapper.value = 'shop_by_mood';
            wrapper.associatedObject = 'shopBy-carousel';

            const pushObject = this.getInfoHome(wrapper);

            const numOfDisplyedItems = [];
            const numOfHiddenItems = [];
            let shownItems = [];
            let carouselItems = {};
            let ArrLength = 0;
            let fromSlice = 0;
            let toSlice = 0;

            shopByCarousel.each(function (idx) {
                if (this && this.swiper && this.swiper.slides) {
                    this.swiper.slides.forEach(function (el, idx) {
                        pushObject[idx + ArrLength].index = idx;
                    });
                }

                const dynamicCarouselName = $(this).parent().siblings().find("[class^='cm-'][class*='shopBy'][class$='-headerTitle']").text().toLocaleLowerCase().replace(/ /g, '_');
                wrapper.value = dynamicCarouselName;

                const carouselId = $(this).find('.cm-productList-wrapper').attr('id');

                if (carouselId) {
                    const calculateDisplayedItems = Math.floor(this.swiper.size / this.swiper.slides[0].clientWidth);
                    numOfDisplyedItems.push(calculateDisplayedItems);
                    numOfHiddenItems.push(this.swiper.slides.length - calculateDisplayedItems);

                    if (idx === 0) {
                        toSlice = calculateDisplayedItems;
                    } else {
                        toSlice = ArrLength + calculateDisplayedItems;
                    }

                    shownItems = [...shownItems, ...pushObject.slice(fromSlice, toSlice)];
                    ArrLength += this.swiper.slides.length;

                    carouselItems = {
                        ...carouselItems,
                        [carouselId]: [...pushObject.slice(fromSlice, ArrLength)]
                    };

                    fromSlice = ArrLength;
                }
            });

            if (pushObject.length) {
                this.pushObjectMax({
                    items: shownItems,
                    i: 0,
                    l: numOfDisplyedItems,
                    itemListName: wrapper.value,
                    itemListId: this.helper.getListId()
                });
            }

            const carouselItemTracker = {};

            $('.js-productListNextArrow').on('click', function () {
                const dynamicCarouselName = $(this).parent().siblings().find("[class^='cm-'][class*='shopBy'][class$='-headerTitle']").text().toLocaleLowerCase().replace(/ /g, '_');
                wrapper.value = dynamicCarouselName;

                const carouselId = $(this).attr('aria-controls');
                const carouselContainer = $(`#${carouselId}`).parent();
                const calculateDisplayedItems = Math.floor(carouselContainer[0].swiper.size / carouselContainer[0].swiper.slides[0].clientWidth);
                let selectedItem = [];

                if (!carouselItemTracker[carouselId]) {
                    carouselItemTracker[carouselId] = calculateDisplayedItems;
                } else {
                    carouselItemTracker[carouselId]++;
                }

                if (carouselItems.hasOwnProperty(`${carouselId}`)) {
                    const carouselItemNum = carouselItemTracker[carouselId];
                    selectedItem.push(carouselItems[carouselId][carouselItemNum]);
                }

                if (carouselItemTracker[carouselId] < Number(carouselContainer[0].swiper.slides.length)) {
                    _self.pushObjectMax({
                        items: selectedItem,
                        i: 0,
                        l: 1,
                        itemListName: wrapper.value,
                        itemListId: _self.helper.getListId()
                    });
                }
            });
        }

        if (focusCarousel.length) {
            wrapper.class = '.cm-focus-carousel.swiper-container';
            wrapper.value = 'carousel-home';
            wrapper.associatedObject = 'focus-carousel';

            for (let i = 0; i < focusCarousel.length; i++) {
                this.fillListDataHome(wrapper, i);

                let pushObject = this.getInfoHome(wrapper, i);
                if (pushObject.length) {
                    this.pushObjectMax({
                        items: pushObject,
                        i: 0,
                        l: 8,
                        itemListName: wrapper.value,
                        itemListId: this.helper.getListId()
                    });
                }
            }
        }
    }

    pushSelectInteractionPlp (clickedContainer) {
        this.fillAllListData();

        let container = clickedContainer.find(this.analyticsDataContainer);
        let additionalDataContainer = container.find('.clickAdditionalAttributes');

        const pushData = { ...container.data(), ...additionalDataContainer.data() };
        pushData.quantity = 1;
        let list = pushData.item_list_name;

        let sortingContainer = document.querySelector('.sort-order-item input[type="radio"]:checked');
        if (sortingContainer) {
            list = this.helper.getSortingType(sortingContainer);
            pushData.item_list_name = list;
        }

        if (list === 'listing' ||
            list === 'search' ||
            list === 'category' ||
            list === 'wishlist' ||
            list === 'suggested_products' ||
            list === 'the_most_popular' ||
            list === 'filter_applied' ||
            list === 'best_sellers' ||
            list === 'sorting_decreasing_price' ||
            list === 'sorting_increasing_price' ||
            list === 'new_arrivals' ||
            list === 'complete_your_look' ||
            list === 'quiz_bras' ||
            list === 'carousel_home' ||
            list === 'you_may_also_like' ||
            list === 'complete_the_promo') {
            try {
                localStorage.setItem('listtype', list);
            } catch (e) {}
        }

        localStorage.setItem('lastClickedPosition', pushData.index);
        this.log('Pushing click impression for: ' + pushData.id, true);

        if (!pushData.item_list_id) {
            var provider = pushData.item_list_name === 'you_may_also_like' ? 'google' : null;
            pushData.item_list_id = this.helper.getListId(container, provider);
        }

        let product = this.helper.formatProductForAnalytics(pushData);
        if (product.visualization_type) localStorage.setItem('visualizationTypeProduct' + product.item_id, product.visualization_type);

        this.helper.storeGtmData({
            item_id: pushData.item_id,
            item_variant: pushData.item_variant,
            item_list_name: product.item_list_name,
            item_list_id: product.item_list_id,
            index: pushData.index
        });

        let pushObject = {
            'event': 'select_item',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'ecommerce': {
                'currency': this.helperData.currency,
                'item_list_name': product.item_list_name,
                'item_list_id': product.item_list_id,
                'items': [product]
            }
        };

        this.push({ecommerce: null});
        this.push(pushObject);
    }

    pushSelectInteractionPopup (clickedContainer) {
        this.fillAllListData();

        let container = clickedContainer.find(this.analyticsDataContainer);
        let additionalDataContainer = container.find('.clickAdditionalAttributes');

        let pushData = { ...container.data(), ...additionalDataContainer.data() };
        let list = pushData.item_list_name;

        if (list === 'listing' ||
            list === 'search' ||
            list === 'category' ||
            list === 'wishlist' ||
            list === 'filter_applied' ||
            list === 'best_sellers' ||
            list === 'sorting_decreasing_price' ||
            list === 'sorting_increasing_price' ||
            list === 'new_arrivals' ||
            list === 'you_may_also_like' ||
            list === 'complete_the_promo') {
            try {
                localStorage.setItem('listtype', list);
            } catch (e) {}
        }

        if (!pushData.index && container.closest('.analytics-quickview').length !== 0 && list !== 'cart') {
            try {
                pushData.index = parseInt($(container).data('index')) || parseInt(localStorage.getItem('lastClickedPosition')) || 0;
            } catch (e) {
                pushData.index = 0;
            }
        }
        localStorage.setItem('lastClickedPosition', pushData.index);

        let products = this.helper.formatProductForAnalytics(pushData);
        let selectedSize = $('.product-quickview').find('.form-control[data-attr="size"] input:checked');
        if (selectedSize && selectedSize.length !== 0) {
            products.size = selectedSize.data('attr-value');
            const selectedVariantId = $('.product-quickview').data('pid');
            if (selectedVariantId) {
                products.item_sfcc = this.helper.getCatalogProductId(selectedVariantId);
            }
        }

        let selectedQty = $('.product-quickview').find('.attribute-container[data-attr="QNT"]').eq(1).find('.quantity-value').text();
        products.quantity = selectedQty ? selectedQty.trim() : '1';

        if (products.visualization_type) localStorage.setItem('visualizationTypeProduct' + products.item_id, products.visualization_type);

        this.helper.storeGtmData({
            item_id: pushData.item_id,
            item_variant: pushData.item_variant,
            item_list_name: products.item_list_name,
            item_list_id: products.item_list_id,
            index: pushData.index
        });

        let pushObject = {
            'event': 'select_item',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'ecommerce': {
                'currency': this.helperData.currency,
                'item_list_name': products.item_list_name,
                'item_list_id': products.item_list_id,
                'items': [products]
            }
        };

        this.push({ecommerce: null});
        this.push(pushObject);
    }

    pushSelectInteractionHome (clickedContainer, isQuickview) {
        this.fillAllListData();

        let container = clickedContainer.find(this.analyticsDataContainer);
        let additionalDataContainer = container.find('.clickAdditionalAttributes');

        let pushData = { ...container.data(), ...additionalDataContainer.data() };
        pushData.quantity = 1;
        let list = 'home';

        pushData.index = pushData.index || 0;
        localStorage.setItem('lastClickedPosition', pushData.index);
        localStorage.setItem('listtype', list);
        this.log('Pushing click impression for: ' + pushData.id, true);
        const itemListId = this.helper.getListId();
        pushData.item_list_id = itemListId;
        pushData.item_list_name = list;
        let product = this.helper.formatProductForAnalytics(pushData);
        if (product.visualization_type) localStorage.setItem('visualizationTypeProduct' + product.item_id, product.visualization_type);

        this.helper.storeGtmData({
            item_id: pushData.item_id,
            item_variant: pushData.item_variant,
            item_list_name: product.item_list_name,
            item_list_id: product.item_list_id,
            index: pushData.index
        });

        let pushObject = {
            'event': 'select_item',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'ecommerce': {
                'currency': this.helperData.currency,
                'item_list_name': product.item_list_name,
                'item_list_id': product.item_list_id,
                'items': [product]
            }
        };

        this.push({ecommerce: null});
        this.push(pushObject);
        if (isQuickview) {
            $('body').trigger('product:triggerProductDetailsHome', $(clickedContainer).closest('.analytics-product-home').attr('data-pid'));
        }
    }

    pushSelectInteraction (clickedContainer, itemListName = '', itemIndex = 0) {
        this.fillAllListData();

        let container = clickedContainer.find(this.analyticsDataContainer);
        let additionalDataContainer = container.find('.clickAdditionalAttributes');

        let pushData = { ...container.data(), ...additionalDataContainer.data() };

        if (itemListName) {
            pushData.item_list_name = itemListName;
        }
        if (!isNaN(itemIndex)) {
            pushData.index = itemIndex;
        }

        pushData.quantity = 1;
        // because value returned by data can be different to the one in DOM. "home" instead of listing
        let list = container[0].dataset.item_list_name || additionalDataContainer[0].dataset.item_list_name;
        if (list === 'listing' ||
            list === 'search' ||
            list === 'category' ||
            list === 'wishlist' ||
            list === 'filter_applied' ||
            list === 'best_sellers' ||
            list === 'sorting_decreasing_price' ||
            list === 'sorting_increasing_price' ||
            list === 'new_arrivals' ||
            list === 'recently_viewed' ||
            list === 'complete_your_look' ||
            list === 'you_may_also_like' ||
            list === 'complete_the_promo') {
            try {
                localStorage.setItem('listtype', list);
            } catch (e) {}
        }

        if (!pushData.index && container.closest('.analytics-quickview').length !== 0 && list !== 'cart') {
            try {
                pushData.index = parseInt(localStorage.getItem('lastClickedPosition')) || 0;
            } catch (e) {
                pushData.index = 0;
            }
        }
        localStorage.setItem('lastClickedPosition', pushData.index);

        this.log('Pushing click impression for: ' + pushData.id, true);

        if (!pushData.item_list_id) {
            var provider = pushData.item_list_name === 'you_may_also_like' ? 'google' : null;
            pushData.item_list_id = this.helper.getListId(container, provider);
        }

        let product = this.helper.formatProductForAnalytics(pushData);
        if (product.visualization_type) localStorage.setItem('visualizationTypeProduct' + product.item_id, product.visualization_type);

        this.helper.storeGtmData({
            item_id: pushData.item_id,
            item_variant: pushData.item_variant,
            item_list_name: product.item_list_name,
            item_list_id: product.item_list_id,
            index: product.index
        });

        let pushObject = {
            'event': 'select_item',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'ecommerce': {
                'currency': this.helperData.currency,
                'item_list_name': product.item_list_name,
                'item_list_id': product.item_list_id,
                'items': [product]
            }
        };

        this.push({ecommerce: null});
        this.push(pushObject);
    }

    prepareEinsteinProducts (data) {
        // Take only the viewed elements
        let container = $(data.container).find('.slick-slide.slick-active ' + this.analyticsDataContainer);

        let items = [];
        const itemListId = this.helper.getListId(data.container, 'google');
        for (let i = 0; i < container.length; i++) {
            let obj = container.eq(i).data();
            obj.item_list_name = 'you_may_also_like';
            obj.item_list_id = itemListId;

            var item = this.helper.formatProductForAnalytics(obj);
            item.index = i;
            items.push(item);
            this.pushedItems.push(i);
        }

        var _self = this;

        $('body').on('afterChange', '#ProdRecommendation, ' + data.container, function (event, slick, currentSlide, nextSlide) {
            let allActive = $(data.container).find('.slick-slide.slick-active ' + _self.analyticsDataContainer);

            // All elements for position
            let allProducts = $('#ProdRecommendation').find('.slick-slide ' + _self.analyticsDataContainer);
            let totalProductsNumber = allProducts.length;

            let items = [];

            for (let i = 0; i < allActive.length; i++) {
                let obj = allActive.eq(i).data();
                obj.item_list_name = data.type;
                obj.item_list_id = itemListId;
                var item = _self.helper.formatProductForAnalytics(obj);
                item.index = allActive.eq(i).parents('.slick-slide').data('slick-index');
                if (item.index < 0) {
                    item.index += totalProductsNumber;
                }
                if (_self.pushedItems.indexOf(item.index) === -1) {
                    items.push(item);
                    _self.pushedItems.push(item.index);
                }
            }
            _self.log('Pushing for ' + data.value, true);

            if (items.length > 0) {
                let pushObject = {
                    'event': 'view_item_list',
                    'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
                    'ecommerce': {
                        'currency': _self.helperData.currency,
                        'item_list_name': data.type,
                        'item_list_id': itemListId,
                        'items': items
                    }
                };

                _self.push({ecommerce: null});
                _self.push(pushObject);
                _self.pushedIndexes[data.class] = items.length;
                _self.log('Indexes pushed to: ', true);
                _self.log(_self.pushedIndexes);
            }
        });
    }

    // Homepage observers are being triggered from Coremedia js files
    prepareHomepageObservers () {
        var _self = this;

        $('body').on('hoverOnHotzone', function () {
            if (!Foundation.MediaQuery.atLeast('medium')) {
                return;
            }

            let hoveredItem = $('.cm-popup-icon.cm-imagemap__hotzone--hover');

            if (hoveredItem) {
                let popupId = $(hoveredItem).data('cm-imagemap-target-id');
                let pushObj = $(hoveredItem).siblings('div.cm-popup.cm-popup-' + popupId).find(_self.analyticsDataContainer).data();
                const itemListName = 'landing-home';
                const itemListId = _self.helper.getListId();
                pushObj.item_list_name = itemListName;
                pushObj.item_list_id = itemListId;

                if (_self.mobileBannerCarouselItemsPushed.indexOf(pushObj.index) === -1 && pushObj) {
                    _self.mobileBannerCarouselItemsPushed.push(pushObj.index);
                    pushObj = _self.helper.formatProductForAnalytics(pushObj);
                    _self.pushObjectMax({
                        items: [pushObj],
                        i: 0,
                        l: 8,
                        itemListName: itemListName,
                        itemListId: itemListId
                    });
                }
            }
        });

        $('body').on('focusCarouselSlideChanged', function (e, data) {
            let carouselId = $(data.swiper.slidesEl).attr('id');
            _self.getNewActiveSlides(data.swiper.slides, carouselId);
        });

        $('body').on('filmstripCarouselSlideChange', function (e, data) {
            if (!Foundation.MediaQuery.atLeast('medium')) {
                let carouselId = $(data.swiper.slidesEl).attr('id');
                _self.getNewActiveSlides(data.swiper.slides, carouselId);
            }
        });

        $('body').on('click touchend', '.cm-single-hero-banner-container .cm-imagemap__hotzone, .cm-special-category-banner .cm-imagemap__hotzone', function (e) {
            let analyticsArray = [];
            _self.activeCarouselId = $(e.currentTarget).data('cm-imagemap-target');

            // check if the carousel was reopened from the user
            if (_self.openedCarousels.indexOf(_self.activeCarouselId) === -1) {
                _self.openedCarousels.push(_self.activeCarouselId);

                let activeCarousel = $(e.currentTarget).siblings(_self.activeCarouselId);
                $(activeCarousel).find('.cm-product-item.swiper-slide').toArray().forEach((item, index) => {
                    let analyticsDiv = $(item).find(_self.analyticsDataContainer);
                    $(analyticsDiv).attr('data-index', index);
                    $(analyticsDiv).attr('data-item_list_name', 'carousel-home');

                    // push only the 2 active slides
                    if ($(item).hasClass('swiper-slide-active') || $(item).hasClass('swiper-slide-next')) {
                        _self.mobileBannerCarouselItemsPushed.push(_self.activeCarouselId + '-' + $(item).attr('aria-label'));
                        analyticsArray.push(_self.formatHomepageProduct(analyticsDiv));
                    }
                });
                _self.pushObjectMax({
                    items: analyticsArray,
                    i: 0,
                    l: 8,
                    itemListName: 'carousel-home',
                    itemListId: _self.helper.getListId()
                });
            }
        });

        $('body').on('mobileBannerCarouselSlideChange', function (e, data) {
            let analyticsArray = [];

            // find all the active items after the user scrolled
            data.swiper.slides.forEach(item => {
                if ($(item).hasClass('swiper-slide-prev') || $(item).hasClass('swiper-slide-active') || $(item).hasClass('swiper-slide-next')) {
                    let itemId = _self.activeCarouselId + '-' + $(item).attr('aria-label');

                    if (_self.mobileBannerCarouselItemsPushed.indexOf(itemId) === -1) {
                        _self.mobileBannerCarouselItemsPushed.push(itemId);
                        analyticsArray.push(_self.formatHomepageProduct($(item).find(_self.analyticsDataContainer)));
                    }
                }
            });

            if (analyticsArray.length) {
                _self.pushObjectMax({
                    items: analyticsArray,
                    i: 0,
                    l: 8,
                    itemListName: 'carousel-home',
                    itemListId: _self.helper.getListId()
                });
            }
        });
    }

    prepareProductObservers () {
        var _self = this;
        $('body').on('search:showMoreContentLoaded', function (e) {
            _self.pushAllLists();
        });
    }

    prepareTilesObservers () {
        var _self = this;

        $('.wishlistItemCards').on('click', '.line-item-name, .product-image', function (e) {
            const $target = $(this).closest('.product-info');
            _self.pushSelectInteraction($target);
        });

        // Click event only for an item
        $('body').on('click', '.product .product-tile .image-container, .product .tile-body, .product .price-container, .product .quickview.quick-add', function (e, data) {
            const target = $(this).closest('.product');
            if ($('.product-detail') && $('.product-detail').length >= 1) {
                _self.pushSelectInteraction(target);
            } else {
                _self.pushSelectInteractionPlp(target);
            }
        });

        $('body').on('click', '.js-orderDetails-pageLink', function (e) {
            const $currentTarget = $(e.currentTarget).closest('.analytics-orderDetails-pageLink');
            const analyticsIndex = $currentTarget.data('analytics-index') || 0;
            _self.pushSelectInteraction($currentTarget, 'buy_it_again', analyticsIndex);
        });

        $('body').on('click', '.product .analytics-pdp-link-name', function (e, data) {
            const target = $(this).closest('.product');
            if ($(e.currentTarget).closest('.theMostPopularContainer').length !== 0 || $(e.currentTarget).closest('.suggestedProductsContainer').length !== 0) {
                return;
            }
            if ($('.product-detail') && $('.product-detail').length > 1) {
                _self.pushSelectInteraction(target);
            } else {
                _self.pushSelectInteractionPlp(target);
            }
        });

        $('body').on('click', '.analytics-completeTheLook-pdpList', function () {
            var $item = $(this);
            var $scope = $item.closest('[data-analytics-list-type], .suggestedProductsPromoContainer, .js-pdp-cross-sell-modal');
            var listType = 'match_with';
            var index = $scope.find('.analytics-completeTheLook-pdpList').index(this);

            _self.pushSelectInteraction($item, listType, index);
            try {
                localStorage.setItem('listtype', listType);
            } catch (e) {
                console.warn('Unable to set listtype inside local storage: {}', e);
            }
        });

        $('body').on('click', '.analytics-completeThePromo-pdpList', function () {
            var $item = $(this);
            var $scope = $item.closest('[data-analytics-list-type], .suggestedProductsPromoContainer, .js-pdp-cross-sell-modal');
            var listType = 'complete_the_promo';
            var index = $scope.find('.analytics-completeThePromo-pdpList').index(this);

            _self.pushSelectInteraction($item, listType, index);
            try {
                localStorage.setItem('listtype', listType);
            } catch (e) {
                console.warn('Unable to set listtype inside local storage: {}', e);
            }
        });

        // Click event from home
        $('body').on('click', '.analytics-product-home .image-container, .analytics-product-home .product-info-box', function (e, data) {
            const target = $(e.currentTarget).closest('.analytics-product-home');
            _self.pushSelectInteractionHome(target, false);
        });

        // Open quickview from home
        $('body').on('click', '.analytics-product-home .image-container .js-quickview-link', function (e) {
            e.stopPropagation();
            const target = $(e.currentTarget).closest('.analytics-product-home');
            _self.pushSelectInteractionHome(target, true);
        });

        $('body').on('click touchstart', '.analytics-quickview', function (e, data) {
            var position;
            var list;

            try {
                position = parseInt(localStorage.getItem('lastClickedPosition')) || 0;
                list = localStorage.getItem('listtype');
            } catch (e) {
                position = 0;
                list = 'listing';
            }

            $(this).find('.analytics')
                .attr({
                    'data-item_list_name': list,
                    'data-index': position
                });

            const target = $(this).closest('.product-name');
            _self.pushSelectInteractionPopup(target);
        });

        $('body').on('click', '.product-image', function (e, data) {
            if ($(e.currentTarget).closest('.bonus-product-card').length !== 0) {
                return;
            }
            const isFromCartList = $(this).closest('.analytics-cart-line-item').length > 0;
            if (isFromCartList) {
                return;
            }
            if ($('.page').data('action') === 'Wishlist-Show') {
                return;
            }
            if ($(e.currentTarget).closest('.wishlist-minicart').length !== 0) {
                return;
            }
            if ($(e.currentTarget).closest('.analytics-mini-cart').length !== 0) {
                return;
            }
            // Skip this event for the links in the Order Details page as they have a different event with more specific data
            if ($(e.currentTarget).closest('.js-orderDetails-product__link').length !== 0) {
                return;
            }
            // Skip this event for the links in the Order It Again modal as they have a different event with more specific data
            if ($(e.currentTarget).closest('.js-orderAgain-modal__product-link').length !== 0) {
                return;
            }
            let target = $(this).closest('.product-quickview').find(_self.analyticsDataContainer);
            target.data('item_list_name', localStorage.getItem('listtype'));
            target = target.closest('.analytics-quickview');
            if ($(e.currentTarget).closest('.product-quickview').length !== 0) {
                _self.pushSelectInteractionPopup(target);
            } else {
                _self.pushSelectInteraction(target);
            }
        });

        $('body').on('click', '.analytics-cart-line-item .analytics-line-item-name a', function (e, data) {
            return _self.pushSelectInteractionInCart($(this).closest('.analytics-cart-line-item').find('.analytics.checkout.checkout-product'));
        });

        $('body').on('click', '.js-orderDetails-product__link', function (e, data) {
            let index = parseInt($(this).closest('.product-info').find('.analytics.productListingItem').data('index'));
            if (isNaN(index)) {
                index = $(this).closest('.product-info').index() - 1; // -1 because of the order details header
            }
            return _self.pushSelectInteraction($(this).closest('.product-info'), 'buy_it_again', index);
        });

        $('body').on('click', '.js-orderAgain-modal__product-link', function (e, data) {
            return _self.pushSelectInteraction($(this).closest('.analytics-order-again'), 'buy_it_again' /* Only one item in the modal, so index is 0 */);
        });
    }

    pushSelectInteractionInCart ($container) {
        this.fillAllListData();
        const product = this.helper.formatProductForAnalytics($container.data());
        product.item_list_id = 'cart';
        if (product.visualization_type) localStorage.setItem('visualizationTypeProduct' + product.item_id, product.visualization_type);

        this.helper.storeGtmData({
            item_id: product.item_id,
            item_variant: product.item_variant,
            item_list_name: product.item_list_name,
            item_list_id: product.item_list_id,
            index: product.index
        });
        let pushObject = {
            'event': 'select_item',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'ecommerce': {
                'currency': this.helperData.currency,
                'item_list_name': product.item_list_name,
                'item_list_id': product.item_list_id,
                'items': [product]
            }
        };

        this.push({ecommerce: null});
        this.push(pushObject);

        localStorage.setItem('listtype', product.item_list_name);
    }

    prepareObservers () {
        var _self = this;

        $('body').on('product:crossSellLoaded', function (e, data) {
            let start = 0;
            let length = Foundation.MediaQuery.atLeast('medium') ? 3 : 2;
            let fromMinicart = data && data.fromMinicart ? data.fromMinicart : false;
            let isCompletePromo = data && data.isCompletePromo;
            if (data && !data.loadHead) {
                start = Foundation.MediaQuery.atLeast('medium') ? 3 : 2;
                length = -1;
            } else {
                _self.prepareProductObservers();
            }

            if (fromMinicart) {
                const listValue = isCompletePromo ? 'complete_the_promo_minicart' : 'complete_your_look_minicart';
                _self.pushList(listValue);
            } else if (isCompletePromo) {
                _self.pushList('complete_the_promo');
                _self.pushList('complete_your_look');
            } else {
                _self.pushList('complete_your_look');
                _self.pushList('recently_viewed');
            }
        });
        $('body').on('listing:einsteinloaded', function (e, data) {
            _self.listsAvailable = _self.helper.getAvailableListTypes(_self.listingItemsBaseClass);
            _self.prepareEinsteinProducts(data);
            _self.pushList('you_may_also_like');
        });

        setTimeout(function () {
            $('body').trigger('listing:js-loaded');
        }, 2000);

        $('body').on('product:crossSellError', function (e, data) {
            _self.prepareProductObservers();
            _self.pushAllLists();
        });

        $('body').on('listing:filter_or_sort_applied', function (e, data) {
            for (let index = 0; index < data.dataArray.length; index++) {
                data.dataArray[index] = _self.helper.formatProductForAnalytics(data.dataArray[index]);
                data.dataArray[index].index = index;
            }
            if (data.dataArray && data.dataArray.length !== 0) {
                localStorage.setItem('listtype', data.dataArray[0].item_list_name);
            }
            _self.listsAvailable = _self.helper.getAvailableListTypes(_self.listingItemsBaseClass);
            _self.pushObjectMax({
                items: data.dataArray,
                i: 0,
                l: 8,
                itemListName: data.listType,
                itemListId: _self.helper.getListId()
            });
        });

        $('body').on('search:productsSuggestions', function (e, data) {
            let analyticsItems = [];
            const itemListName = 'search';
            let responseDom = document.createElement('html');
            responseDom.innerHTML = data.response;
            let productElements = responseDom.querySelectorAll('.analytics.productListingItem');

            if (productElements.length <= 0) {
                return;
            }

            productElements.forEach((el, index) => {
                let analyticsObject = $(el).data();
                analyticsObject.item_list_name = itemListName;
                analyticsObject.index = index;
                analyticsObject = _self.helper.formatProductForAnalytics(analyticsObject);
                analyticsItems.push(analyticsObject);
            });

            _self.pushObjectMax({
                items: analyticsItems,
                i: 0,
                l: 8,
                itemListName: itemListName,
                itemListId: _self.helper.getListId()
            });

            // Populate analytics divs inside the html with extra info needed
            $('.suggestions-wrapper .analytics.productListingItem').toArray().forEach((item, index) => {
                item.setAttribute('data-index', index);
                item.setAttribute('data-item_list_name', 'search');
            });
        });

        $('body').on('bonusProduct:quickviewOpen', function (e, data) {
            if (data.products.length > 1) {
                for (let i = 0; i < data.products.length; i++) {
                    const $container = $(data.container).find('.analytics.productListingItem').eq(i);
                    _self.helper.setBonusProductData($container, i);
                }
                _self.pushData({
                    'class': 'freeProduct',
                    'value': 'free_product',
                    'associatedObject': '#chooseBonusProductModal'
                });
            }
        });

        $('body').on('listing:orderAgainItems', function (e, data) {
            _self.listsAvailable = _self.helper.getAvailableListTypes(_self.listingItemsBaseClass);
            _self.pushList(data.type);
        });

        $('body').on('listing:orderDetailsItems', function (e, data) {
            _self.pushOrderDetailsList(data.type);
        });

        $('body').on('analytics:similarProductModalOpened', function (e, data) {
            _self.listsAvailable = _self.helper.getAvailableListTypes(_self.listingItemsBaseClass);
            _self.pushList(data.type);
        });
    }

    pushObjectRange (data) {
        if (data.length === -1) {
            data.length = data.items.length;
        }
        if (data.start < 0 || data.start >= data.items.length || data.length < 1) {
            return;
        }
        let pushObject = {
            'event': 'view_item_list',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'ecommerce': {
                'currency': this.helperData.currency,
                'item_list_name': this.helper.formatString(data.itemListName),
                'item_list_id': data.itemListId,
                'items': data.items.slice(data.start, data.start + data.length)
            }
        };
        this.push({ecommerce: null});
        this.push(pushObject);
    }

    pushObjectMax (data) {
        if (data.items.length > 0) {
            // Condition for do-while
            let condition = true;
            // Number of items
            var nItems = data.items.length;
            var list = '';
            let idx = 0;
            let sortingContainer = document.querySelector('.sort-order-item input[type="radio"]:checked');
            if (sortingContainer) {
                list = this.helper.getSortingType(sortingContainer);
            } else {
                list = this.helper.formatString(data.itemListName);
            }

            do {
                if (data.items.length > 0) {
                    if (Array.isArray(data.l)) {
                        let pushObject = {
                            'event': 'view_item_list',
                            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
                            'ecommerce': {
                                'currency': this.helperData.currency,
                                'item_list_name': Array.isArray(data.itemListName) ? data.itemListName[idx] : list,
                                'item_list_id': data.itemListId,
                                'items': data.items.slice(data.i, data.l[idx])
                            }
                        };

                        if (!pushObject.ecommerce.item_list_name || pushObject.ecommerce.item_list_name === '') {
                            return;
                        }

                        this.push({ecommerce: null});
                        this.push(pushObject);
                        nItems -= data.l[idx];
                        data.i += data.l[idx];
                        idx = idx + 1;
                        data.l = data.l[idx - 1] + data.l[idx];
                    } else if (data.items.length === 1) {
                        let pushObject = {
                            'event': 'view_item_list',
                            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
                            'ecommerce': {
                                'currency': this.helperData.currency,
                                'item_list_name': data.items[0].item_list_name,
                                'item_list_id': data.itemListId,
                                'items': data.items.slice(data.i, data.l)
                            }
                        };
                        this.push({ecommerce: null});
                        this.push(pushObject);
                        nItems -= 1;
                    } else {
                        let pushObject = {
                            'event': 'view_item_list',
                            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
                            'ecommerce': {
                                'currency': this.helperData.currency,
                                'item_list_name': Array.isArray(data.itemListName) ? data.itemListName[idx] : list,
                                'item_list_id': data.itemListId,
                                'items': data.items.slice(data.i, data.l)
                            }
                        };
                        this.push({ecommerce: null});
                        this.push(pushObject);
                        idx++;
                        // Increment of pointer
                        data.i += 8;
                        data.l += 8;
                        // Decrement of items pushed
                        nItems -= 8;
                    }

                    // Condition exit do-while
                    if (nItems <= 0) {
                        condition = false;
                    }
                }
            } while (condition);
        }
    }
}

const obj = new AnalyticsListings();
module.exports = obj;
